import PropTypes from "prop-types";
import GmailMessage from "./GmailMessage";

const GmailThread = ({ messages, activeMessageId = null, setActiveMessageId }) => {
  return (
    <div className="tw-flex tw-flex-col">
      {messages.map((message) => (
        <GmailMessage
          key={message.id}
          message={message}
          activeMessageId={activeMessageId}
          toggleMessage={setActiveMessageId}
        />
      ))}
    </div>
  );
};

GmailThread.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  activeMessageId: PropTypes.string,
  setActiveMessageId: PropTypes.func.isRequired,
};

export default GmailThread;
